import React from 'react'
import { Button } from 'reactstrap'
import i18n from '@configs/i18n'
import '@styles/base/pages/page-misc.scss'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
    this.handleTryAgain = this.handleTryAgain.bind(this)
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    console.error('[ErrorBoundary]', error, errorInfo)
  }

  handleTryAgain() {
    this.setState({ hasError: false })
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className='misc-wrapper'>
          <div className='misc-inner p-2 p-sm-3'>
            <div className='w-100 text-center'>
              <h2 className='mb-1'>{i18n.t("common.something_went_wrong")}</h2>
              <p className='mb-2'>
                {i18n.t("common.unexpected_error")}
              </p>
              <Button.Ripple color='primary' className='btn-sm-block mb-1 mr-1' onClick={this.handleTryAgain}>
                {i18n.t("common.try_again")}
              </Button.Ripple>
              <Button.Ripple color='secondary' className='btn-sm-block mb-1' onClick={() => { window.location.href = '/' }}>
                {i18n.t("common.back_to_home")}
              </Button.Ripple>
            </div>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
